export function useGetValid($element: HTMLInputElement, options: OptionsVE): ResultVE {
	const result: ResultVE = {
		valid: false,
		error: false,
		message: '',
	};

	if (!options.noEmpty) {
		if ($element.type === 'radio' && $element.name) {
			const $group: NodeListOf<HTMLInputElement> = document.querySelectorAll(`input[type="radio"][name="${$element.name}"]`);

			const valid = Array.from($group).some(($radio: HTMLInputElement) => $radio.checked);

			result.valid = valid;
			result.error = !valid;

			return result;
		}

		const valid = $element.checked;

		result.valid = valid;
		result.error = !valid;
	}

	return result;
}
